<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container">
    <div class="title">
        <h4>Listado de areas</h4>
        <button type="button" class="btn btn-primary" routerLink="/addArea">Agregar Area</button>
    </div>
    
    <table *ngIf="listAreas.length > 0" class="table table-hover ">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listAreas" class="table-active">
            <td>{{ item.name }}</td>

            <td>
                <button routerLink="/editArea/{{ item.id }}" type="button" class="btn btn-info btn-sm">Edit</button>
                <button (click)="deleteArea(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 *ngIf="listAreas.length == 0">No hay turnos para mostrar</h5>
</div>
